import { createSelector } from "reselect"
import { AppState } from "../rootReducer"

const getDataProvisioningWorkflowState = (state: AppState) => state.dataProvisioningWorkflow;
export const getDataProvisioningWorkflowStateSelector = createSelector(getDataProvisioningWorkflowState,(dataProvisioningWorkflowReducer) => dataProvisioningWorkflowReducer);

